import { Dimensions1, Dimensions3 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const infoAlert = css({
  '&.MuiAlert-root': {
    marginTop: Dimensions3,
    marginBottom: Dimensions1,
  },
});

const RoleCardStyles = {
  infoAlert,
};

export default RoleCardStyles;
